import React from "react";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { Box, Typography } from "@mui/material";

interface IconeNovoProps {
  label?: string;
  color?: string
}

export const IconeNovo: React.FC<IconeNovoProps> = ({ label = "novo", color = "#01579b" }) => {
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        border: "1px solid",
        borderColor: color,
        borderRadius: "999px",
        px: 0.8,
        py: 0.1,
      }}
    >
      <AutoAwesomeIcon
        sx={{
          fontSize: 14,
          color: color,
          mr: 0.5,
        }}
      />
      <Typography
        variant="caption"
        sx={{
          fontWeight: 500,
          color: color,
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};
